
import React, {useContext, useState} from 'react';
// import Excel from 'exceljs';
import XlsxPopulate, { fromFileAsync } from 'xlsx-populate';
import styled from 'styled-components';
import { GlobalContext } from '../contexts/GlobalContext';

import {Button, Dropdown} from 'semantic-ui-react';
import { Spreadsheet } from 'react-spreadsheet';
import ViewAsToggleComponent from '../components/ViewAsToggleComponent';
import DropFileComponent from './DropFileComponent';

import * as dataManager from '../adapters/data';

import * as lodash from 'lodash';

import {
    DataSheetGrid,
    checkboxColumn,
    textColumn,
    keyColumn,
} from 'react-datasheet-grid';


const HeaderDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 110px;
    padding-bottom: 60px;
    margin-left: 60px;
    margin-right: 60px;

    @media screen and (max-width: 425px) {
        margin-left: 19px;
        margin-right: 19px;
    }
`;

const HeaderText = styled.text`
    font-family: Poppins;
    font-size: 18px;

    @media screen and (max-width: 768px) {
        display: none;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
`;


const EmployeeDiv = styled.div`
    align-items: center;
    display: flex;
    height: 74px;
    justify-content: space-between;
    outline: 1px solid #E2E2E2;
`;

const EmployeeInfoDiv = styled.div`
    display: flex;
    justify-content: space-between;
    width: 100%;

    @media screen and (max-width: 768px) {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }
`;

const EmployeeName = styled.text`
    color: #464646;
    font-family: Poppins;
    font-size: 14;
    margin-left: 60px;
    min-width: 300px;
    width: 300px;
    padding-right: 285px;

    @media screen and (max-width: 768px) {
        min-width: unset;
        width: auto;
        padding-right: 0px;
        // padding-right: 180px;
    }

    @media screen and (max-width: 425px) {
        margin-left: 19px;
    }

    @media screen and (max-width: 320px) {
        // padding-right: 80px;
    }
`;

const EmployeeQuals = styled.text`
    color: #464646;
    font-family: Poppins;
    font-size: 14;
    width: 100%;

    @media screen and (max-width: 768px) {
        min-width: unset;
        margin-right: 80px;
        text-align: right;
    }

    @media screen and (max-width: 425px) {
        margin-right: 10px;
    }
`;

const EmployeeButtonsDiv = styled.div`
    display: flex;

    margin-right: 60px;

    @media screen and (max-width: 768px) {
        display: none;
    }

    @media screen and (max-width: 425px) {
        display: none;
    }
`;

const EmployeeButtonsMobileDiv = styled.div`
    margin-right: 19px;
    display: none;

    @media screen and (max-width: 768px) {
        margin-right: 60px;
         display: block;
    }

    @media screen and (max-width: 425px) {
        margin-right: 19px;
         display: block;
    }
`;

const AddEmployeeButton = styled.button`
    color: #fff;
    background: rgba(29, 89, 155, 1);
    border-radius: 9px;
    width: 177px;
    height: 44px;
    border: none;

    :hover {
        background: rgba(29, 89, 155, 0.8);
        cursor: pointer;
    }
`;

const LabelDiv = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: 60px;
    margin-right: 60px;

    @media screen and (max-width: 425px) {
        margin-left: 19px;
    }
    
`;

const LabelInfoDiv = styled.div`
    padding-top: 80px;
    padding-bottom: 26px;

    @media screen and (max-width: 768px) {
        padding-right: 120px;
        padding-top: 0px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-width: unset;
    }

    @media screen and (max-width: 425px) {
        padding-right: 0px;
        padding-top: 0px;
        padding-bottom: 0px;
        display: flex;
        justify-content: space-between;
        width: 100%;
        min-width: unset;
    }
`;

const LabelText = styled.text`
    color: #595959;
    font-weight: 600;
    font-family: Poppins;
    font-size: 14px;
    text-transform: uppercase;
    padding-top: 80px;
    padding-bottom: 26px;
`;

const LabelNameText = styled.text`
    color: #595959;
    font-weight: 600;
    font-family: Poppins;
    font-size: 14px;
    text-transform: uppercase;
    padding-top: 80px;
    padding-bottom: 26px;
    padding-right: 300px;

    @media screen and (max-width: 768px) {
         padding-right: 0px;
    }

    @media screen and (max-width: 425px) {
        padding-right: 0px;
        // padding-right: 190px;
    }

    @media screen and (max-width: 320px) {
        padding-right: 0px;
    }
`;

const FixedDiv = styled.div`
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 9999;
`;


const Employee = (props)  => {
    return (
        <EmployeeDiv aria-label={`employee ${props.name}`}>
            <EmployeeInfoDiv>
                <EmployeeName>{props.name}</EmployeeName>
                <EmployeeQuals aria-label={`${props.name}'s qualifications`}>{props.qualifications?.map( q => (<span>{q.name}  </span>))}</EmployeeQuals>
            </EmployeeInfoDiv>
            <EmployeeButtonsDiv>
                <Button aria-label={`Edit ${props.name}'s details`} color='blue' onClick={props.editEmployeeCallback}>Edit</Button><Button aria-label={`Delete ${props.name} employee`} basic onClick={props.confirmDeleteCallback}>Delete</Button>
            </EmployeeButtonsDiv>
            <EmployeeButtonsMobileDiv>
                <Button aria-label={`Edit ${props.name}'s details`} className='ui icon button' onClick={props.editEmployeeCallback}><i className='ellipsis vertical icon'></i></Button>
            </EmployeeButtonsMobileDiv>
        </EmployeeDiv>
    );
}



const EmployeesPage = (props) => {

    const [context, setContext] = useContext(GlobalContext);
    const [excelData, setExcelData] = useState([]);
    const [qualNames, setQualNames] = useState([]);

    const [viewMode, setViewMode] = useState('List');

    const handleViewMode = (mode) => {
        if (mode == 'list') {
            setViewMode('List');
        }
        else if (mode == 'grid') {
            setViewMode('Grid');
        }
    }

    const handleDrop = (files) => {
        let fileType = files[0].name.split('.').pop();
        console.log(files[0]);
        

        switch (fileType) {
            case 'xlsx':
                loadExcel(files[0]);
                break;
            // case 'txt':
            // case 'template':
            //     loadScheduleTemplate(files[0]);
            //     break;
            default:
                console.log(`Could not load file. ${fileType} not supported`);

        }

    }

    const loadExcel = async (file) => {

        const reader = new FileReader();
        XlsxPopulate.fromDataAsync(file)
        .then( (wb) => {

            console.log(wb, ' - workbook instance');
            let rowsArray = [];

            let sheets = wb.sheets();
            console.log(sheets);

            let values = wb.sheet(0).usedRange().value();
            // console.log(`Values: ${values[0][0]}`);

            for (let i = 0; i < values.length; i++) {
                console.log(`array length - ${values.length}`);
                let colsArray = [];
                for (let j = 0; j < values[i].length; j++) {
                    if (typeof values[i][j] !== 'object') {
                        colsArray.push({value: values[i][j]});
                        // console.log(`colsArray - values[${i}][${j}]: ${values[i][j]}`);
                    }
                    else if (typeof values[i][j].text !== 'object') { // for Rich-Text cells
                        colsArray.push({value: values[i][j].text()});
                        // console.log(`colsArray - values[${i}][${j}]: ${values[i][j].text()}`);
                    }
                    else {
                        console.log(`PROBLEM - ${JSON.stringify(values[i][j])}`);
                        alert(`Error loading cell [${i}, ${j}]: ${JSON.stringify(values[i][j])}`);
                    }
                }
                rowsArray.push(colsArray);
                //console.log(`rowsArray: ${rowsArray}`);
            }
            setContext( (prev) => { return {...prev, employeeExcelData: rowsArray} });

        });

/// LOAD VIA EXCELJS
        // const wb = new Excel.Workbook();
        // const reader = new FileReader()

        // reader.readAsArrayBuffer(file)
        // reader.onload = () => {
        //     const buffer = reader.result;
        //     wb.xlsx.load(buffer).then(workbook => {

        //         //save 
        //         // wb.xlsx.writeBuffer().then( (data) => {
        //         //     let blob = new Blob([data]);
        //         //     fs.saveAs(blob, 'test2.xlsx');
        //         // });

        //         console.log(workbook, 'workbook instance')
        //         let arr2 = [];
        //         workbook.eachSheet((sheet, id) => {
                    

        //             sheet.eachRow((row, rowIndex) => {
        //                 console.log(row.values, rowIndex)
        //                 let arr = [];
                        
        //                 lodash.forEach(row.values, (v) => {
        //                     arr = [...arr, {value: v}];
        //                 }) 

        //                 arr2 = [...arr2, arr];
        //                 // console.log(arr2);

        //                 // setData([...data, arr]);
                        
        //                 // setData([row.values.map( (e) => { return {value: e} })]);
        //                 // console.log(data)
        //                 // setData([...data, row.values.map( (e) => {
        //                 //     return {value: e}
        //                 // })]);

        //                 // setExcelData( (prevData) => [...prevData, row.values.map( (e) => { return {value: e} })]);

        //                 // setContext( (prev) => { return {...prev, showDropFileComponent: false} })
        //             });


        //         })
        //         console.log(`arr2 - ${JSON.stringify(arr2)}`);
        //         setContext( (prev) => { return {...prev, employeeExcelData: arr2} });
                
        //     });
        // }
/// END OF LOAD VIA EXCELJS


    }

    const setEmployeeCell = (selectedCells) => {

        console.log('Employee set');


        context['selectedCells'].map( (e) => {
            console.log('selected employee - ', e);

            //ensure cell doesn't already exist in array.
            if ( context['employeeCells'].find( (f) => {
                return (f.column === e.column && f.row === e.row);
            }) === undefined ) {
                // add selected cell(s) to employeeCells
                setContext( (prevContext) => { //set employeeCells to selectionCells
                    return {...prevContext, employeeCells: [...prevContext['employeeCells'], e]}
                } );
            }
            else {
                // don't add because it already exists in the positionCells array
            }


            
        });
    }

    const unsetEmployeeCell = (selectedCells) => {
        console.log('Unset employee cell');


        context['selectedCells'].map( (e) => {

            //ensure cell exists in array.
            if ( context['employeeCells'].find( (f) => {
                return (f.column === e.column && f.row === e.row);
            }) === undefined ) {
                // don't remove because it doesn't exist in the positionCells array
            }
            else {
                // remove selected cell(s) from employeeCells
                setContext( (prevContext) => { //unset employeeCells to selectionCells
                    return {...prevContext, employeeCells: [...prevContext['employeeCells'].filter( (f) => {
                        // console.log('iterate:  ', f);
                        // console.log('remove', e);
                        console.log('iterate: ', f.row, f.column)
                        return (f.row !== e.row || f.column !== e.column)
                    })]}
                } );
            }
            
        });
    }

    const clearSheet = () => {
        setContext( (prev) => {
            return {...prev, employeeExcelData: [], showDropFileComponent: true}
        });
    }

    return (
        props.active === 'employees' ? (
        <React.Fragment>
            <HeaderDiv>
                <HeaderText>{ context['employees'] ? context['employees'].length : 0 } Employees</HeaderText>
                <AddEmployeeButton onClick={props.addEmployeeCb}>Add Employee</AddEmployeeButton>
                {/* <div style={{display: 'flex', alignItems: 'center', gap: '10px'}}>
                    <HeaderText>View as {viewMode}</HeaderText>
                    <ViewAsToggleComponent handleClick={handleViewMode} />
                </div> */}
            </HeaderDiv>


            {/* <FixedDiv> */}
                
                {/* <Button onClick={unsetEmployeeCell}>Unset Employee to Selected Cells</Button> */}
                {/* <Button onClick={() => {saveScheduleTemplate(data, context['positionCells'])}}>Save Schedule Template</Button> */}
            {/* </FixedDiv> */}


            <DropFileComponent handleDrop={handleDrop} show={(context['employeeExcelData'] === null || context['employeeExcelData'] === undefined || context['employeeExcelData'].length == 0)}>
                Import Employees by Dragging Spreadsheet (.xlsx) Here
            </DropFileComponent>

            { context['employeeExcelData'] === null || context['employeeExcelData'] === undefined || context['employeeExcelData'].length == 0 ? '' :
                <div>
                    <Button onClick={props.setEmployeeCellCb } style={{color: 'white', background: 'rgba(29, 89, 155, 1)'}}>Import Employees from Spreadsheet</Button>
                    <Button onClick={props.setQualsCellCb }>Import Qualifications from Spreadsheet</Button>
                    <Button onClick={props.setPositionCellCb }>Import Positions from Spreadsheet</Button>
                    <Button onClick={clearSheet }>Clear Sheet</Button>

                    <br />
                    <div style={{padding: 15, overflowX: 'auto'}}>
                        <Spreadsheet 
                                    data={context['employeeExcelData']} 
                                    onSelect={ (selected)=> {
                                        // // Set selected cells to 'EMPLOYEE CELLS'
                                        setContext( (prevContext) => {
                                            return {...prevContext, selectedCells: selected}
                                        } );


                                        // if (selected?.length > 0) {
                                        //     selected.map( (e) => {
                                        //         console.log(JSON.stringify(data[e.row][e.column]));
                                        //     });
                                        // }
                                        // console.log(`Selection: ${JSON.stringify(selected)}`);
                                        // console.log(`Value: ${JSON.stringify(data[selected[0].row][selected[0].column])}`)
                                    }}

                        />
                    </div>
                </div>
                }

            {
                viewMode === 'List' ? 
                    <LabelDiv>
                        <LabelInfoDiv><LabelNameText>Name</LabelNameText><LabelText>Qualifications</LabelText></LabelInfoDiv>
                    </LabelDiv>
                : <br />
            }

            {
            context['employees'] ?
                // viewMode === 'Grid' ? 
                //     <DataSheetGrid
                //         data={context['employees']}
                //         columns={[
                //             { ...keyColumn('name', textColumn), title: 'Name' },
                //             { ...() => ({   columnData: context['qualifications'], 
                //                             component: () => (<b>test</b>)}), 
                //                             title: 'Qualifications' }
                //         ]}
                //      />
                // :
                    context['employees'].map(employee => (
                        <Employee name={employee.name} qualifications={employee.qualifications} context={context}
                        confirmDeleteCallback={props.confirmDeleteCb('employee', 'Delete Employee', ' employee?',employee.name, employee.id)}
                        editEmployeeCallback={props.editEmployeeCb(employee.name, employee.id, employee.qualifications)}
                        />
                    ))
            : <p>No employees</p>
            }

        </React.Fragment>
        ) : <React.Fragment></React.Fragment>
    );
}

export default EmployeesPage;